<template>
  <b-form-group class="col-12" label="Integration System:">
    <b-row>
      <b-col
        v-for="(option) in integrationSystemList"
        :key="option.value || option"
        cols="12" md="6" lg="3"
        class="mb-3"
      >
        <b-card
          :class="['integration-system-card', { active: isActive(option) }]"
          @click="select(option)"
          style="cursor:pointer; min-height: 200px;"
        >
          <div class="d-flex flex-column align-items-center justify-content-center h-100">
            <img
              v-if="option.image"
              class="img-fluid mb-2"
              :src="'https://stagingadmin.lacoreconnect.com'+option.image"
              :alt="option.text || option.label || option.value || option"
              style="max-height: 200px;"
            />
            <div v-if="!option.image" class="display-4 font-weight-bold text-center mb-2">
              {{ option.text || option.label || option.value || option }}
            </div>
            <div v-else class="font-weight-bold text-center">
              {{ option.text || option.label || option.value || option }}
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  name: 'IntegrationSystemSelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    isStorefrontConfig: {
      type: Boolean,
      default: false
    }
  },
  data() {
    if(!this.isStorefrontConfig) {
      return {
        integrationSystemList: [
          { value: 'BrightPearl', image: '/img/integrations/brightpearl.png', text: 'BrightPearl' }
        ]
      };
    }
    return {
      integrationSystemList: [
        { value: 'ShipStationDirectV1', image: '/img/integrations/shipstation.png', text: 'ShipStation (Pass-Through)' },
        { value: 'ShipStationV2', image: '/img/integrations/shipstation.png', text: 'ShipStation V2 (Pass-Through)' },
        { value: 'Manual', image: '/img/logo-dark.png', text: 'Connect API' },
        { value: 'ShopifyDirect', image: '/img/integrations/shopify.png', text: 'Shopify: Fulfillment Service' },
        { value: 'ShopifyDirect_Simple', image: '/img/integrations/shopify.png', text: 'Shopify: Sync with Merchant Location' },
        { value: 'WooCommerceDirect', image: '/img/integrations/woocommerce.jpg', text: 'WooCommerce' },
        { value: 'CartRoverThirdParty', image: '/img/integrations/cartrover.png', text: 'CartRover (Pass-Through)' },
        { value: 'BigCommerce_Direct_StoreAPI', image: '/img/integrations/bigcommerce.png', text: 'BigCommerce' },
        { value: 'BrightPearl', image: '/img/integrations/brightpearl.png', text: 'BrightPearl' },
        { value: 'FtpImport', image: null, text: 'SFTP' }
      ]
    };
  },
  methods: {
    select(option) {
      const val = option.value || option;
      if (val !== this.value) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    isActive(option) {
      return (option.value || option) === this.value;
    }
  }
};
</script>